<div>
  <div class="tile-padding">
    <ng-template #utilityBarForm>

      <!-- tw:px-3 = 12px, matching the main content card's side margins (tw:mx-3). -->
      <div class="filter tw:px-3 tw:pb-4 tw:flex tw:flex-wrap tw:items-end tw:gap-2" [ngClass]="{'hidden': !showPanel}">
        <div class="tw:flex-1">
          <crm-user-select (onSelectedItemChanged)="onUserDataChanged($event)" class="fullwidth"></crm-user-select>
        </div>
        <div><button class="btn-outline-primary btn" name="Search" value="Search" (click)="filterSearch()">Search</button>
      </div>
    </div>

  </ng-template>
</div>
@if (media.isActive('xs') && !loading) {
  <div>
    <mat-tab-group>
      <mat-tab label="Today">
        <student-sessions-tile [sessionTileParams]="sessionTileParams" [currDate]="currDate"  class="grid-primary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>
      </mat-tab>
      <mat-tab label="This Week">
        <student-sessions-tile [sessionTileParams]="sessionDataThisWeek" [currDate]="currDate" class="grid-primary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>
      </mat-tab>
      <mat-tab label="Last Week">
        <student-sessions-tile [sessionTileParams]="sessionDataLastWeek" [currDate]="currDate" class="grid-secondary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>
      </mat-tab>
      <mat-tab label="Next Week">
        <student-sessions-tile [sessionTileParams]="sessionDataNextWeek" [currDate]="currDate" class="grid-secondary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>
      </mat-tab>
    </mat-tab-group>
  </div>
}
@if (! media.isActive('xs') && !loading) {
  <div>
    <student-sessions-tile [sessionTileParams]="sessionTileParams" [currDate]="currDate" class="grid-primary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>
    <student-sessions-tile [sessionTileParams]="sessionDataThisWeek" [currDate]="currDate" class="grid-secondary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>
    <student-sessions-tile [sessionTileParams]="sessionDataLastWeek" [currDate]="currDate" class="grid-secondary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>
    <student-sessions-tile [sessionTileParams]="sessionDataNextWeek" [currDate]="currDate" class="grid-secondary" *checkFeatureRender="'StudentSessionsView'"></student-sessions-tile>
  </div>
}
</div>
